import React from 'react';
import ReactDOM from 'react-dom';
import SelectedLegsList from '../SelectedLegs';
import Icon from '../../Icon';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { toggleHRBetSlip } from 'Store/actions/horseRacing/betSlipActions';
import { PROGRAM_TYPES } from 'Store/constants/horseRacing';
import { decimalFormatterLast } from 'Utils/decimalFormatter';
import { classnames } from 'Utils/classnames';
import EnvironmentManager from 'Utils/environmentManager';


const MobileBetSlip = ({
  selectedLegs,
  legNumbers,
  cost,
  multiplier,
  onChange,
  onBlur,
  onFocus,
  onButtonClick,
  buttonDisabled,
  saveClearButtonDisabled,
  onSaveClick,
  onClearClick,
  isAnimating,
  legsCounts,
  betType,
  isBetWithComma,
  verify,
  couponCount
}) => {
  const { isOpen, combinedHorses } = useSelector(state => state.horseRacing.betSlip);
  const programType = useSelector(state => state.horseRacing.allHippodromes.programType);

  
  const dispatch = useDispatch();
  const onArrowClick = () => {
    dispatch(toggleHRBetSlip(!isOpen));
  };


  return ReactDOM.createPortal(<div className="newBetSlip__mobile">
    <SelectedLegsList isBetWithComma={ isBetWithComma } legsCounts={ legsCounts } legNumbers={ legNumbers }
      selectedLegs={ selectedLegs } isMobile betType={ betType }/>
    <div className="newBetSlip__mobile-bottom">
      <div className="buttons">
        <div className={ saveClearButtonDisabled && 'disabled' } onClick={ onClearClick }>
          <Icon iconName="svgTrashWhite"/>
        </div>
        {
          (((programType === PROGRAM_TYPES.FIXED && EnvironmentManager.getMessageText({ key: 'tjkapp_v1.bulletin_fixodd.couponSaveAvailable' }) === 'true')) || (programType === PROGRAM_TYPES.JOINT))
          && <div className={ buttonDisabled && 'disabled' } onClick={ !buttonDisabled && onSaveClick }>
            <Icon iconName="svgSave"/>
          </div>
        }


      </div>
      <div className="multiplier">
        <span>Misli</span>
        <div className="inputArea">
          <input id="multiplier" maxLength={ 5 } type="text" inputMode="numeric" value={ multiplier } onChange={ onChange }
            onBlur={ onBlur } onFocus={ onFocus }/>
          <Icon iconName="svgArrowRightWhite"/>
        </div>
      </div>
      <div className="info">
        { programType === PROGRAM_TYPES.JOINT && <span>Bahis: { (verify?.data?.body?.column || verify?.error?.extras?.column || 0) }</span> }
        <span>{ couponCount > 1 ? couponCount : '' } Kupon Tutarı: { cost }</span>
        { programType === PROGRAM_TYPES.FIXED && !(combinedHorses?.some(h => h?.horse?.propositionInfo?.spbah === true))
          && <span>Kazanç: { (() => {
            const errorAmount = verify?.error?.extras?.fixedOddVerifyResponse?.expectedWinAmount;
            const dataAmount = verify?.data?.body?.fixedOddVerifyResponse?.expectedWinAmount;

            if (verify?.error) {
              return decimalFormatterLast(errorAmount);
            }

            if (dataAmount) {
              return decimalFormatterLast(dataAmount);
            }

            return '0';
          })() } TL</span> }
      </div>
      <button disabled={ buttonDisabled } onClick={ onButtonClick }>Hemen Oyna</button>
    </div>
    <div onClick={ onArrowClick } className={ classnames({
      'newBetSlip__mobile-indicator': true,
      animated: isAnimating,
    }) }>
      Kuponumu Gör
      <Icon iconName="svgDoubleArrow"/>
    </div>
  </div>, document?.body);
};

MobileBetSlip.propTypes = {
  selectedLegs: PropTypes.object,
  legsCounts: PropTypes.object,
  legNumbers: PropTypes.number,
  couponCount: PropTypes.number,
  cost: PropTypes.string,
  multiplier: PropTypes.number,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  onButtonClick: PropTypes.func,
  buttonDisabled: PropTypes.bool,
  isAnimating: PropTypes.bool,
  isBetWithComma: PropTypes.bool,
  saveClearButtonDisabled: PropTypes.bool,
  betType: PropTypes.string,
  verify: PropTypes.object
};

export default MobileBetSlip;
